module.exports = __webpack_public_path__ + "static/img/-6_42.6bed353.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/issue6/-6_42.jpg
// module id = Ouco
// module chunks = 7